import React, { useEffect, useState } from 'react'
import classes from './home.module.css'
import { List, Row, Col, Space,  Image } from 'antd'
import {useNewsListQuery } from '../store/ReactWebSiteApi'
import dayjs from 'dayjs';
import WebNewsCheck from './WebNewsCheck'
import {ClockCircleOutlined,EyeOutlined} from '@ant-design/icons';
import WebMain from './WebMain'
function WebNews(props) {
     const {data, isSuccess} = useNewsListQuery({en_e_id:'218'});     
     const [list, setList] = useState();     
     useEffect(() => {
         if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {en_id:key,en_name,en_num,en_content,en_ctime,en_state,en_type_name,en_image} = item;
                    return item = {key,en_name,en_num,en_content,en_ctime,en_state,en_type_name,en_image}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.en_ctime;
                    let bTimeString = b.en_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }             
        }
    }, [data, isSuccess])

    //点击量
    return (
       <WebMain selectedKeys='news'>
            <Row style={{backgroundColor:"#fff",padding:"60px"}}>            
                <Col span={5} ></Col>
                <Col span={14} >
                <div className={classes.newsMain}>                                    
                    <List
                        size="large"
                        itemLayout="horizontal"
                        dataSource={list}
                        renderItem={(item, index) => {
                            if(item.en_state==='2'){
                                return (
                                    <List.Item key={item.key}>
                                        <List.Item.Meta
                                            avatar={<Image 
                                                        src={`/api/assets/images/application/${item.en_image}`} 
                                                        shape="square"
                                                        width={200}
                                                        height={160}
                                                        style={{borderRadius:'10px'}}
                                                    />}
                                            title={ <WebNewsCheck
                                                        text={item.en_name}
                                                        en_id={item.key}
                                                        en_image={item.en_image}
                                                    />}
                                            description={
                                                <Space 
                                                    style={{
                                                        fontSize:"16px",
                                                        marginLeft:'20px',
                                                        marginTop:"5px"
                                                    }}
                                                >
                                                    <ClockCircleOutlined /> {dayjs(item.en_ctime).format('YYYY年MM月DD日')}
                                                    <EyeOutlined style={{marginLeft:"60px"}} /> {item.en_num}
                                                </Space>
                                            }
                                        />
                                    </List.Item>
                                )
                            }else{
                                return <div key={item.key}></div>
                                
                            }
                            
                        }}
                    >
                    </List>                   
                </div>
                </Col>
                <Col span={5}></Col>
            </Row>
       </WebMain>
    )
}

export default WebNews